/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ShortlistProfileResponse } from './';
import {
    ShortlistProfileResponseFromJSON,
    ShortlistProfileResponseFromJSONTyped,
    ShortlistProfileResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ShortlistResponse
 */
export interface ShortlistResponse {
    /**
     * 
     * @type {string}
     * @memberof ShortlistResponse
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof ShortlistResponse
     */
    expiryTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof ShortlistResponse
     */
    maxItems: number;
    /**
     * 
     * @type {Array<ShortlistProfileResponse>}
     * @memberof ShortlistResponse
     */
    profiles: Array<ShortlistProfileResponse>;
}

/**
 * Check if a given object implements the ShortlistResponse interface.
 */
export function instanceOfShortlistResponse(value: object): value is ShortlistResponse {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('maxItems' in value) || value['maxItems'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    return true;
}

export function ShortlistResponseFromJSON(json: any): ShortlistResponse {
    return ShortlistResponseFromJSONTyped(json, false);
}

export function ShortlistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShortlistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'expiryTime': json['expiryTime'] == null ? undefined : (new Date(json['expiryTime'])),
        'maxItems': json['maxItems'],
        'profiles': ((json['profiles'] as Array<any>).map(ShortlistProfileResponseFromJSON)),
    };
}

export function ShortlistResponseToJSON(value?: ShortlistResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'expiryTime': value['expiryTime'] == null ? undefined : ((value['expiryTime']).toISOString().substring(0,10)),
        'maxItems': value['maxItems'],
        'profiles': ((value['profiles'] as Array<any>).map((v) => ShortlistProfileResponseToJSON(v))),
    };
}

